/**
 * @file index.js
 * @module src/index
 * @description
 * **Entry point of the EDALab React application.**
 * - Initializes and renders the root React component inside the HTML DOM.
 * - Wraps the app with `<ContextProviders />` to inject global context.
 * - Renders `<EDALab />` as the main component.
 * - This file is automatically used by React scripts to bootstrap the app.
 *
 * @version
 * <p>
 *  2025-07-22: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import EDALab from './js/EDALab';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <EDALab />
    </React.StrictMode>
);

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('is-preload');
    requestAnimationFrame(() => {
        setTimeout(() => {
            document.body.classList.remove('banner-preload');
        }, 20); // if set too low, start-up animation may not play
    });
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
